export default "__VITE_ASSET__DqNFbFut__"